export const decorationDesign = {
    address: '地址',
    ':': '：',
    designer: '设计师',
    time: '时间',
    copyDesignLink: '复制方案链接',
    share: '分享',
    addToProject: '添加到项目',
    houseType: '户型图',
    threeViews: '3视图',
    graphicSolution: '图文方案',
    constructionDrawing: '施工图',
    constructionSchedule: '施工进度',
    contractSmartAssistant: '合同智能助手',
    budgetList: '预算清单',
    constructionArea: '建筑面积',
    realArea: '室内面积',
    download: '下载',
    allSelect: '全选',
    selected: '已选',
    zhang: '张',
    batchDeletion: '批量删除',
    batchDownload: '批量下载',
    allTypes: '全部类型',
    normalGraph: '普通类型',
    topView: '俯视图',
    panorama: '全景图',
    budgetPrivew: '预算概览',
    project: '工程项目',
    auxiliaryMaterial: '辅材',
    hardMountingMaterials: '硬装主材',
    upholsteredFurniture: '家具软装',
    item: '项',
    shareLink: '分享链接到微信打开',
    copyLink: '复制链接',
    qrCodeShare: '微信扫码分享',
    weiChartScan: '微信扫码查看',
    copysuccessful: '复制成功',
    all: '全部',
    enterWay: '玄关',
    livingRoom: '客厅',
    area: '建筑面积：',
    inner: '套内面积：',
    houseAddress: '楼盘地区：',
    price: '楼盘均价：',
    squareMeter: '平米',
    priceUnit: '元/㎡',
    planArea: '户型面积',
    kitchen: '厨',
};
